/**
 * Drag payload shared between the photo library and the collage cells.
 *
 * The MIME entries are the primary channel, but `dataTransfer` custom types are
 * not equally reliable across browsers (Safari has historically dropped them),
 * and `getData` is unreadable during `dragover` by design. This module-level
 * mirror is set on `dragstart` and cleared on `dragend`, so a drop always knows
 * what is being carried.
 */
export const DRAG_ASSET = 'application/x-nextcollage-asset';
export const DRAG_CELL = 'application/x-nextcollage-cell';

interface Payload {
  assetId: string | null;
  cellId: string | null;
}

export const dragPayload: Payload = { assetId: null, cellId: null };

export function beginAssetDrag(dt: DataTransfer, assetId: string) {
  dt.setData(DRAG_ASSET, assetId);
  dt.effectAllowed = 'copy';
  dragPayload.assetId = assetId;
  dragPayload.cellId = null;
}

export function beginCellDrag(dt: DataTransfer, cellId: string) {
  dt.setData(DRAG_CELL, cellId);
  dt.effectAllowed = 'move';
  dragPayload.cellId = cellId;
  dragPayload.assetId = null;
}

export function endDrag() {
  dragPayload.assetId = null;
  dragPayload.cellId = null;
}
